import {Timestamp} from "google-protobuf/google/protobuf/timestamp_pb";

export const toTimestamp = (date: Date): Timestamp => {
    const timestamp = new Timestamp();
    timestamp.setSeconds(Math.floor(date.getTime() / 1000));
    timestamp.setNanos((date.getTime() % 1000) * 1_000_000);
    return timestamp;
};